import bindClient from './client/bind';
import { IContainer } from './interface/container';
import bindMessage from './message/bind';
import privateContainer from './private/container';
import bindUtil from './util/bind';

export interface IBinder {
    bind: (container: IContainer) => void;
    unbind: (container: IContainer) => void;
    expose: (srcContainer: IContainer, dstContainer: IContainer) => void;
}

/* list of binders sorted in order of installation */
const binders: Array<{ binder: IBinder; isPrivate: boolean }> = [
    {
        binder: bindClient,
        isPrivate: false,
    },
    {
        isPrivate: true,
        binder: bindUtil,
    },
    {
        isPrivate: true,
        binder: bindMessage,
    },
];

export function bindAll(container: IContainer) {
    binders.forEach(binder => binder.binder.bind(container));
}

function setup(containerGlobal: IContainer) {
    const prvContainer = privateContainer(containerGlobal);

    /* bind all to private container */
    bindAll(prvContainer);

    /* expose (pre-bound instantiated values/objects) to parent global container from private
       container. This is to ensure both containers use the same object ref (if injectable is 
       an instantiated value). */
    binders
        .filter(binder => !binder.isPrivate)
        .forEach(binder => binder.binder.expose(prvContainer, containerGlobal));
}

export default setup;
